var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_icon_",
    "data-name": "remove icon ",
    transform: "translate(-1139 -892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2445",
    "data-name": "Ellipse 2445",
    transform: "translate(1139 892)",
    fill: "#fff",
    stroke: "#616161",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "remove_icon",
    "data-name": "remove  icon",
    transform: "translate(40.947 406.947)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18737",
    "data-name": "Rectangle 18737",
    width: 14,
    height: 14,
    transform: "translate(1103.053 490.053)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(1106.526 493.526)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1127",
    "data-name": "Line 1127",
    x1: 8,
    y2: 8,
    transform: "translate(-0.474 -0.475)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1128",
    "data-name": "Line 1128",
    x2: 8,
    y2: 8,
    transform: "translate(-0.474 -0.475)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.48885cac22efa493e23df1c9b80efa27.svg";
export { ForwardRef as ReactComponent };